import {
  Action,
  ActionType,
  ICSVDownloadStudentListResponse,
} from "../../../models/classchangemanagement/getCSVStudentListData";
import createReducer from "../../createReducer";

export interface CSVDownloadStudentListReducerType {
  loading: boolean;
  error?: string;
  csvDownloadStudentListResponse?: ICSVDownloadStudentListResponse;
}

const defaultState: CSVDownloadStudentListReducerType = {
  loading: false,
  error: undefined,
  csvDownloadStudentListResponse: undefined,
};

export const getCSVDownloadStudentListReducer =
  createReducer<CSVDownloadStudentListReducerType>(defaultState, {
    [ActionType.GET_CSV_DOWNLOAD_STUDENT_LIST](
      state: CSVDownloadStudentListReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_CSV_DOWNLOAD_STUDENT_LIST_ERROR](
      state: CSVDownloadStudentListReducerType,
      action: Action<string>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_CSV_DOWNLOAD_STUDENT_LIST_SUCCESS](
      state: CSVDownloadStudentListReducerType,
      action: Action<ICSVDownloadStudentListResponse>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        csvDownloadStudentListResponse: action.payload,
      };
    },

    [ActionType.GET_CSV_DOWNLOAD_STUDENT_LIST_RESET](
      state: CSVDownloadStudentListReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        csvDownloadStudentListResponse: [],
      };
    },
  });
